import { type ClassName, twx } from '@ctw/shared/utils/tailwind';
import type { PropsWithChildren } from 'react';

export interface DisclaimerProps extends PropsWithChildren {
  className?: ClassName;
}

export const Disclaimer = ({ className, children }: DisclaimerProps) => {
  return <p className={twx('text-[10px] text-content-subtle italic', className)}>{children}</p>;
};
